export default __webpack_public_path__ + "static/media/D3-2.4c5de205.png";